window.addEventListener('DOMContentLoaded', () => {
	window.add_new_item = function(id) {
	  $(id).find(".links a.add_fields").click()
	}
});
